import { atom } from 'recoil';
import { IGraduacao } from '../../commons/types/crm';


export const graduacoesAtom = atom<IGraduacao[]>({
  key: 'graduacoes', 
  default: [] as IGraduacao[],
}); 
